var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.to ? 'router-link' : _vm.href ? 'a' : 'button',_vm._g(_vm._b({tag:"component",staticClass:"btn",class:[`btn--${_vm.variant}`, `btn--${_vm.size}`],attrs:{"to":_vm.to,"href":_vm.to ? undefined : _vm.href}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }